import styled from "styled-components";

import { colors } from "../../global/globalStyle";

export interface ICircleCSS {
  widthHeight?: number;
  border?: string;
  backgroundColor?: string;
  colorIcon?: string;
  disabled?: boolean;
}

export const CircleDiv = styled.div<ICircleCSS>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${(props) => (props.widthHeight ? props.widthHeight + "px" : "20px")};
  height: ${(props) => (props.widthHeight ? props.widthHeight + "px" : "20px")};
  border-radius: 50%;
  margin: 2px;

  border: ${(props) => props.border ?? `2px solid ${colors.primary_default}`};
  background-color: ${(props) => props.backgroundColor ?? "none"};
  cursor: pointer;
  &:hover {
    background-color: ${colors.primary_default};
    .MuiSvgIcon-root {
      color: ${colors.neutral_white};
    }
  }
  .MuiSvgIcon-root {
    color: ${(props) => props.colorIcon ?? colors.primary_default};
  }
`;

export const CircleDivDisabled = styled.div<ICircleCSS>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${(props) => (props.widthHeight ? props.widthHeight + "px" : "20px")};
  height: ${(props) => (props.widthHeight ? props.widthHeight + "px" : "20px")};
  border-radius: 50%;
  border: 2px solid ${colors.neutral_gray_70};
  background-color: ${colors.neutral_gray_70};
  margin: 2px;

  .MuiSvgIcon-root {
    color: ${colors.neutral_gray_90};
  }
`;
